// extracted by mini-css-extract-plugin
module.exports = {"backLink":"NewView_backLink__3YVgK","newView":"NewView_newView__2ieFj"};